import { useAuth } from "@clerk/clerk-react";
import { SocketIo } from "App";
import RulesCharts from "Components/Charts/RulesCharts/RulesCharts";
import StageChange from "Components/StageChange/StageChange";
import { Card, CardContent, CardHeader } from "Components/ui/card";
import { Skeleton } from "Components/ui/skeleton";
import UseInnerWidth from "hooks/UseInnerWidth";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import danger from "../../Assets/Images/danger.svg";
import {
  getChallengeRules,
  getChartsHistory,
} from "../../Redux/ChallengeRules/ChallengeRulesActions";
import AddonCard from "./ChallengeRuleComponents/AddonCard/AddonCard";
import MinimumTradingDays from "./ChallengeRuleComponents/MinimumTradingDays/MinimumTradingDays";
import ProgressBar from "./ChallengeRuleComponents/ProgressBar/ProgressBar";
import RuleCard from "./ChallengeRuleComponents/RuleCard/RuleCard";
import ChallengeTabs from "Components/ChallengeTabs/ChallengeTabs";
import mt5Icon from "Assets/Images/mt5icon.svg";
import tradelockerIcon from "Assets/Images/tradelockerIcon.svg";
import ruleDot from "../../Assets/Images/ruleDot.svg";
import redDotRule from "../../Assets/Images/redDotRule.svg";
import greyDotRules from "../../Assets/Images/greyDotRules.svg";
import { useTheme } from "hooks/ThemeContext";
import TradeLockerBlack from "Assets/Images/TradeLockerBlack.svg";

function ChallengeRules() {
  const { theme } = useTheme();
  const [selected, setSelected] = useState();
  const { challengeStageInfo, challengeStageInfoLoading } = useSelector(
    (state) => state.ChallengeOverviewReducer
  );
  const greyDot = false;
  const dispatch = useDispatch();

  const { getToken } = useAuth();

  const { id } = useParams();

  useEffect(() => {
    if (id) dispatch(getChallengeRules(getToken, id));
  }, [id]);
  useEffect(() => {
    if (challengeStageInfo?.Account?.login && !challengeStageInfoLoading) {
      dispatch(
        getChartsHistory(
          getToken,
          encodeURIComponent(challengeStageInfo?.Account?.login)
        )
      );
    }
  }, [challengeStageInfo]);

  const { history, getHistoryLoading } = useSelector(
    (state) => state.ChallengeRulesReducer
  );

  const { rules, getRolesLoading } = useSelector(
    (state) => state.ChallengeRulesReducer
  );

  const [newData, setNewData] = useState([]);

  useEffect(() => {
    history?.length > 0 &&
      setNewData(
        history?.map((item) => ({
          time: new Date(item?.createdAt)?.getTime() / 1000,
          value: item?.equity,
        }))
      );
  }, [history]);

  const [newPercentage, setNewPercentage] = useState({});
  const [newDrowdown, setNewDrowdown] = useState({});

  useEffect(() => {
    setNewPercentage({
      profitTarget: rules?.profitTarget?.percentage,
      profitStatus: rules?.profitTarget?.status,
    });

    setNewDrowdown({
      ...rules?.drawdown,
    });
  }, [rules]);

  useEffect(() => {
    SocketIo.on(`${challengeStageInfo?.Account?.login}`, (innerData) => {
      if (
        newData?.findIndex(
          (item) =>
            item?.time == new Date(innerData?.createdAt)?.getTime() / 1000
        ) === -1
      ) {
        setNewData((prev) => [
          ...prev,
          {
            time: new Date(innerData?.createdAt)?.getTime() / 1000,
            value: innerData?.equity,
          },
        ]);
      }
    });

    return () => {
      SocketIo.off(`${challengeStageInfo?.Account?.login}`);
    };
  }, [newData]);

  useEffect(() => {
    if (challengeStageInfo?.Account?.login) {
      SocketIo.on(
        `OnTargetChange_${challengeStageInfo?.Account?.login}`,
        (data) => {
          setNewPercentage({
            profitTarget: data?.percentage,
            profitStatus: data?.status,
          });
        }
      );

      SocketIo.on(`DrawDown_${challengeStageInfo?.Account?.login}`, (data) => {
        setNewDrowdown({
          ...data,
        });
      });
    }
  }, [challengeStageInfo]);

  useEffect(() => {}, [newPercentage]);

  const navigate = useNavigate();

  const { scrollValue, scrollable } = useSelector(
    (state) => state.ScrollVariablesSlice
  );

  const [counter, setCounter] = useState(0);
  const [counterUp, setCounterUp] = useState(0);
  const width = UseInnerWidth();

  return (
    <div className="">
      {challengeStageInfo?.status == "BREACHED" && (
        <div className="flex items-center gap-4 bg-red-opacity w-full p-4 rounded-lg mb-4">
          <img src={danger} className="w-6 h-6" alt="danger" />
          <div>
            <div className="flex flex-col gap-2 text-red">
              Disqualification Notice: Rule Breached
            </div>
            <div className="text-red opacity-50">
              Reason: {challengeStageInfo?.breachReason}
              <span className="text-grey  text-xs">
                {"("}
                {new Date(challengeStageInfo?.updatedAt).toLocaleDateString(
                  "en-US",
                  {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  }
                )}
                {")"}
              </span>
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-col gap-4">
        <div className="flex sm:items-center justify-between sm:flex-row flex-col ">
          <div className="flex items-baseline gap-3 w-fit text-nowrap">
            <div className="text-2xl font-N_Medium flex flex-row gap-4 item-center">
              {!challengeStageInfoLoading &&
                (challengeStageInfo?.Challenge?.Platform?.name?.toLowerCase() ===
                "platform 5" ? (
                  <img src={mt5Icon} alt="mt5" className="w-[0.95rem]" />
                ) : (
                  <img
                    src={theme === "light" ? TradeLockerBlack : tradelockerIcon}
                    alt="tradelockerIcon"
                    className="w-[1.05rem]"
                  />
                ))}
              Challenge {!challengeStageInfoLoading && "-"}{" "}
              {challengeStageInfo?.Account?.login}{" "}
            </div>
          </div>
          <div className=" sm:my-0 my-4 ">
            <StageChange />
          </div>
        </div>
        <ChallengeTabs page="rules" />
      </div>
      <div
        className={`mt-6 grid ${
          width > 1300
            ? "grid-cols-3"
            : width > 768
            ? "grid-cols-2"
            : "grid-cols-1"
        } gap-6`}
      >
        {getRolesLoading || getHistoryLoading ? (
          <Card
            className={`w-full border-none bg-background ${
              width <= 1300 && width > 768 && "col-span-2"
            }`}
          >
            <CardHeader className="space-y-2">
              <div className="flex items-center justify-between">
                <Skeleton className="h-7 w-32" />
                <Skeleton className="h-6 w-20 rounded-full" />
              </div>
              <Skeleton className="h-4 w-40" />
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="space-y-6">
                <div className="space-y-2">
                  <Skeleton className="h-4 w-12" />
                  <Skeleton className="h-4 w-24" />
                </div>
                <Skeleton className="h-24 w-full rounded-lg " />
              </div>
            </CardContent>
          </Card>
        ) : (
          <RuleCard
            className={width <= 1300 && width > 768 && "col-span-2"}
            title={"Profit Target"}
            subtitle={
              <div>
                <div className="font-N_Bold text-xl">
                  {rules?.profitTarget?.rulePercentage}%
                </div>
                <div className="font-N_Thin text-sm text-white-opacity">
                  profit target must be achieved
                </div>
              </div>
            }
            status={
              newPercentage?.profitStatus?.toLowerCase() === "pending"
                ? "disabled"
                : "Passing"
            }
            statusText={
              newPercentage?.profitStatus?.toLowerCase() === "pending" &&
              "Pending"
            }
            greyDot={newPercentage?.profitStatus?.toLowerCase() === "pending"}
          >
            <ProgressBar
              max={rules?.profitTarget?.rulePercentage}
              value={
                newPercentage?.profitTarget < 0
                  ? 0.0
                  : newPercentage?.profitTarget
              }
            />
          </RuleCard>
        )}
        <div className="flex flex-col gap-4 justify-between w-full col-span-2">
          {rules?.dailyDrawdown?.status?.toLowerCase() !== "inactive" &&
            (getRolesLoading || getHistoryLoading ? (
              <Card className="w-full border-none bg-background ">
                <CardHeader className="space-y-2">
                  <div className="flex items-center justify-between">
                    <Skeleton className="h-7 w-48" />
                    <Skeleton className="h-6 w-20 rounded-full" />
                  </div>
                  <Skeleton className="h-4 w-56" />
                </CardHeader>
                <CardContent className="space-y-2">
                  <div className="relative h-60">
                    {/* Dashed line pattern */}
                    <Skeleton className="absolute top-1/2 left-0 right-0 h-[1px]" />
                    <Skeleton className="absolute top-0 bottom-0 left-1/2 w-[1px]" />
                  </div>
                </CardContent>
              </Card>
            ) : (
              <RuleCard
                title={"Your Drawdown"}
                status={null}
                noGap
                withoutPadding
              >
                <div className="flex flex-col h-full justify-between">
                  <div className="flex items-center gap-2 px-6">
                    <div className="pr-10 flex flex-col-reverse gap-3 border-r-2 border-border-darkNew">
                      <div className="text-sm font-G_Regular text-white-opacity">
                        Max Daily Loss (
                        {newDrowdown?.maxDailyLoss
                          ? newDrowdown?.maxDailyLoss?.toLocaleString("en-US", {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 2,
                              style: "currency",
                              currency: "USD",
                            })
                          : "$0"}
                        )
                      </div>
                      <div className="flex items-center gap-2 justify-between">
                        <div>
                          {newDrowdown?.dailyValue
                            ? newDrowdown?.dailyValue?.toLocaleString("en-US", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                                style: "currency",
                                currency: "USD",
                              })
                            : "$0"}
                        </div>
                        <div
                          className={`responsiveInnerText border-2 flex flex-row items-center gap-2 rounded-full px-2 text-base ${
                            newDrowdown?.dailyStatus === "Passing"
                              ? "border-green text-green"
                              : newDrowdown?.dailyStatus === "Failed"
                              ? "border-conditions-failOpacity text-red"
                              : `border-conditions-disabledOpacity text-white-opacity ${
                                  !greyDot && "px-3"
                                }`
                          }`}
                        >
                          <div className="font-N_Bold text-sm">
                            {newDrowdown?.dailyStatus}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="pl-8 flex flex-col-reverse gap-3">
                      <div className="text-sm font-G_Regular text-white-opacity">
                        Max Loss (
                        {newDrowdown?.maxLoss
                          ? newDrowdown?.maxLoss?.toLocaleString("en-US", {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 2,
                              style: "currency",
                              currency: "USD",
                            })
                          : "$0"}
                        )
                      </div>
                      <div className="flex items-center gap-2 justify-between">
                        <div>
                          {" "}
                          {newDrowdown?.maxValue
                            ? newDrowdown?.maxValue?.toLocaleString("en-US", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                                style: "currency",
                                currency: "USD",
                              })
                            : "$0"}
                        </div>
                        <div
                          className={`responsiveInnerText border-2 flex flex-row items-center gap-2 rounded-full px-2 text-base ${
                            newDrowdown?.maxDrawdownStatus === "Passing"
                              ? "border-green text-green"
                              : newDrowdown?.maxDrawdownStatus === "Failed"
                              ? "border-conditions-failOpacity text-red"
                              : `border-conditions-disabledOpacity text-white-opacity ${
                                  !greyDot && "px-3"
                                }`
                          }`}
                        >
                          <div className="font-N_Bold text-sm">
                            {newDrowdown?.maxDrawdownStatus}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <RulesCharts
                    data={newData.filter(
                      (item, index, self) =>
                        index === self.findIndex((t) => t.time === item.time)
                    )}
                    variant={
                      newDrowdown?.dailyStatus?.toLowerCase() === "failed" ||
                      newDrowdown?.dailyStatus?.toLowerCase() === "at risk"
                        ? "primary"
                        : "secondary"
                    }
                    dailyDrawdownValue={newDrowdown?.dailyDrawdownValue}
                    maxDrawdownValue={newDrowdown?.maxDrawdownValue}
                    maxBalance={newDrowdown?.startOfDayBalance}
                    noDailyDrawdown={newDrowdown?.dailyDrawdownValue === 0}
                    noStartBalance={
                      challengeStageInfo?.Challenge?.ChallengeType?.name ==
                      "1-Step Algo"
                    }
                  />
                </div>
              </RuleCard>
            ))}
        </div>
      </div>
      <div className={`flex ${width <= 768 && "flex-col"} gap-6 mt-6`}>
        {getRolesLoading || getHistoryLoading ? (
          <Card
            className={`${
              challengeStageInfo?.Challenge?.isFree
                ? "w-[100%]"
                : width <= 1300
                ? "w-[100%]"
                : "w-3/5"
            } bg-background border-none`}
          >
            <CardHeader className="space-y-2">
              <div className="flex items-center justify-between">
                <Skeleton className="h-7 w-44" />
                <Skeleton className="h-6 w-20 rounded-full" />
              </div>
              <Skeleton className="h-4 w-52" />
            </CardHeader>
            <CardContent className="py-4">
              <div className="flex flex-wrap items-center gap-1.5">
                {/* Generate 20 skeleton bars to represent trading days */}
                {Array.from({ length: 20 }).map((_, i) => (
                  <Skeleton
                    key={i}
                    className="h-12 w-12 aspect-square rounded-full"
                  />
                ))}
              </div>
            </CardContent>
          </Card>
        ) : (
          <RuleCard
            title={"Minimum Trading Days"}
            subtitle={
              <div>
                <div className="font-N_Bold text-xl">
                  {rules?.tradingDays?.minDays} Days
                </div>
                <div className="font-N_Thin text-sm text-white-opacity mb-4">
                  Minimum time to complete each stage for the Only Funds
                  Challenge
                </div>
              </div>
            }
            status={
              rules?.tradingDays?.status === "Pending" ? "Disabled" : "Passing"
            }
            statusText={rules?.tradingDays?.status === "Pending" && "Pending"}
            greyDot={rules?.tradingDays?.status === "Pending"}
            className={`${
              challengeStageInfo?.Challenge?.isFree
                ? "w-[100%]"
                : width <= 1300
                ? "w-[100%]"
                : "w-3/5"
            }`}
          >
            <MinimumTradingDays
              data={rules?.tradingDays?.values}
              lastActiveIndex={rules?.tradingDays?.values?.findLastIndex(
                (item) => item?.exists
              )}
              count={
                rules?.tradingDays?.values?.filter((item) => item?.exists)
                  ?.length
              }
            />
          </RuleCard>
        )}
        {!challengeStageInfo?.Challenge?.isFree &&
          (getRolesLoading || getHistoryLoading ? (
            <Card
              className={`${
                width <= 1300 ? "w-[100%]" : "w-2/5"
              } flex-1 border-none bg-background`}
            >
              <CardHeader className="space-y-2">
                <div className="flex items-center justify-between">
                  <Skeleton className="h-7 w-32" />
                  <Skeleton className="h-6 w-20 rounded-full" />
                </div>
                <Skeleton className="h-4 w-[80%]" />
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="flex items-center justify-between">
                  <Skeleton className="h-10 w-44" />
                  <Skeleton className="h-10 w-20" />
                </div>
              </CardContent>
            </Card>
          ) : (
            <RuleCard
              title={"Addons"}
              subtitle={""}
              newStatus
              statusText={""}
              status={""}
              className={`${width <= 1300 ? "w-[100%]" : "w-2/5"}`}
            >
              <div
                className={`flex ${
                  width < 1300 ? "flex-col" : "flex-row gap-4"
                } items-center `}
              >
                <AddonCard
                  text={
                    "Trade during high-impact news events and get ahead of the market."
                  }
                  price={rules?.news?.price}
                  enabled={rules?.news?.enabled}
                  title={"News Trading"}
                  status={challengeStageInfo?.status}
                />
                <AddonCard
                  text={
                    "Retry the challenge from stage 1 if you failed to meet the rules."
                  }
                  price={rules?.Retry_Challenge?.price}
                  enabled={rules?.Retry_Challenge?.enabled}
                  title={"Retry Challenge"}
                  status={challengeStageInfo?.status}
                />
              </div>
            </RuleCard>
          ))}
      </div>
    </div>
  );
}

export default ChallengeRules;
